import connect from 'components/lib/connect';
import { INBOX_COUNT_MAX } from 'models/inbox_count';
import useTitle from 'scripts/presentation/hooks/use_title';

const TitleContainer = connect(mapStateToProps)(Title);

function mapStateToProps({ getProvider }) {
  const personalInboxCounts = getProvider('personalInboxCounts').get();
  const openCount = (personalInboxCounts && personalInboxCounts.openCount) || 0;

  return {
    openCount,
  };
}

export function Title({ openCount }) {
  let title = document.title;
  if (title === 'Gladly') {
    if (openCount > INBOX_COUNT_MAX) {
      title += ` (999+)`;
    } else if (openCount > 0) {
      title += ` (${openCount})`;
    }
  }

  useTitle(title);
  return null;
}

export default TitleContainer;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/title.jsx